/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_BackInputs */

const en_lesson_back = /** @type {(inputs: Lesson_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to lessons`)
};

const he_lesson_back = /** @type {(inputs: Lesson_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה לשיעורים`)
};

/**
* | output |
* | --- |
* | "Back to lessons" |
*
* @param {Lesson_BackInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_back = /** @type {((inputs?: Lesson_BackInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_BackInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_back(inputs)
	return he_lesson_back(inputs)
});